import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'md-login-page',
  imports: [],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent implements OnInit {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {}

  login(): void {
    this.oidcSecurityService.authorize();
  }

  ngOnInit() {
    this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.router.navigate(['app']);
      } else {
        // Check if we're currently in a callback URL to avoid auto-login during callback
        const urlParams = new URLSearchParams(window.location.search);
        const hasCode = urlParams.has('code');
        const hasError = urlParams.has('error');
        const hasState = urlParams.has('state');

        if (hasCode || hasError || hasState) {
          // withAppInitializerAuthCheck() will handle this automatically
          return;
        }

        this.login();
      }
    });
  }
}
